import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import {
  fetchHistoricPendingCommunication,
  fetchedHistoricPendingCommunication,
  deleteHistoricPendingCommunication,
  deletedHistoricPendingCommunication,
} from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type historicPendingCommunicationListActionPayload = ReturnType<typeof fetchHistoricPendingCommunication>;
type DeleteHistoricPendingCommunicationActionPayload = ReturnType<typeof deleteHistoricPendingCommunication>;

function* historicPendingCommunicationSaga({ payload }: historicPendingCommunicationListActionPayload) {
  const { historicPendingCommunicationApi } = getAPI();
  const response: YieldOf<typeof historicPendingCommunicationApi> = yield call(
    historicPendingCommunicationApi,
    payload
  );
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedHistoricPendingCommunication(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedHistoricPendingCommunication(undefined, error));
  }
}

function* deleteHistoricPendingCommunicationSaga({ payload }: DeleteHistoricPendingCommunicationActionPayload) {
  const { deleteHistoricPendingCommunication } = getAPI();
  const response: YieldOf<typeof deleteHistoricPendingCommunication> = yield call(
    deleteHistoricPendingCommunication,
    payload
  );
  const { ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(deletedHistoricPendingCommunication(true));
  } else {
    const error = problem || 'unknown';
    yield put(deletedHistoricPendingCommunication(false, error));
  }
}

export default function* HistoricPendingSaga() {
  yield takeLatest(fetchHistoricPendingCommunication.type, historicPendingCommunicationSaga);
  yield takeLatest(deleteHistoricPendingCommunication.type, deleteHistoricPendingCommunicationSaga);
}
